import lrsAdapter from '../../helpers/lrs_adapter'
import { parseEntityId } from '../entity'
import getAxiosInstance from '../../helpers/get_axios_instance'

class Chofer {
  static getChofer (cuit) {
    const axios = getAxiosInstance()
    const promise = axios.get(`chofer?r={"clave":{"cuit":"${cuit}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }

  // Funcion utilizada para guardar el telefono de los
  // transportista para utilizar con API de Easy Docking
  static actualizarTelefono (cuit, telefono) {
    const axios = getAxiosInstance()
    const cuitChofer = parseEntityId(cuit)
    const promise = axios.put(`/chofer`,
      `{"valores": {"telefono": "${telefono}"},
       "clave": {"cuit": "${cuitChofer}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }
}

export default Chofer
